import Vue from 'vue'
import App from './App.vue'
import VueParallaxJs from 'vue-parallax-js'
import VueObserveVisibility from 'vue-observe-visibility'
import vaLittle from 'vue-valittle'
import VueMobileDetection from "vue-mobile-detection"
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(vaLittle)
Vue.use(VueParallaxJs)
Vue.use(VueObserveVisibility)
Vue.use(VueMobileDetection);

Vue.use(VueAxios, axios)


Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
